'use client';

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingState } from '@org/design-system';
import type { AuthConfig } from '../types/app-config';
import { useRuntimeAuth } from './auth-context';
import { getLoginPath, isExternalAuthUrl } from './auth-paths';
import { useTranslator } from '../i18n/locale-context';

export interface LogoutPageProps {
  auth?: AuthConfig;
}

export function LogoutPage({ auth }: LogoutPageProps) {
  const navigate = useNavigate();
  const { logout } = useRuntimeAuth();
  const t = useTranslator();

  useEffect(() => {
    logout();
    const loginPath = getLoginPath(auth);

    if (isExternalAuthUrl(loginPath)) {
      window.location.assign(loginPath);
      return;
    }

    navigate(loginPath, { replace: true });
  }, [auth, logout, navigate]);

  return <LoadingState message={t('auth.signingOut')} />;
}
